'use client';
import React from 'react';
import { useSearchParams } from 'next/navigation';

import './tourOption.css';

interface ITourOptionProps {
  startTime: string;
}

export const TourOption = ({ startTime }: ITourOptionProps) => {
  const params = useSearchParams();

  return (
    <div className="tour-option__container">
      <div className="tour-option__col tour-option__col__start">
        <span className="tour-option__label">Start</span>
        <div className="tour-option__value">
          <span className="tour-option__time">{startTime}</span>
          <span className="tour-option__time-format">AM</span>
        </div>
      </div>

      <div className="tour-option__col tour-option__col__end">
        <span className="tour-option__label">Total</span>
        <div className="tour-option__value">
          <span className="tour-option__time">$ 60,00</span>
        </div>
      </div>
    </div>
  );
};
